module.exports = __webpack_public_path__ + "static/media/fondoHeader.9ebb4a17.jpg";